import React from "react";
import skillsData from "../data/skills.json";
import "../styles/skills.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faLaptopCode, 
  faServer, 
  faCogs,
  faDatabase,
  faCheck,
  faStar,
  faAward
} from '@fortawesome/free-solid-svg-icons';

const Skills = () => {
  const getCategoryIcon = (name) => {
    switch(name.toLowerCase()) {
      case 'frontend': return faLaptopCode;
      case 'backend': return faServer;
      case 'erp': return faCogs;
      case 'database': return faDatabase;
      default: return faLaptopCode;
    }
  };

  return (
    <div className="skills-section">
      <div className="skills-header">
        <FontAwesomeIcon icon={faAward} className="skills-heading-icon" />
        <h1 className="skills-title">Core Skills</h1>
        <p className="skills-subtitle">Technologies I excel at</p>
      </div>

      <div className="skills-grid-container">
        {skillsData.categories.map((category) => (
          <div key={category.name} className="skills-category-card">
            <div className="skills-category-header">
              <FontAwesomeIcon 
                icon={getCategoryIcon(category.name)} 
                className="skills-category-icon"
              />
              <h3 className="skills-category-title">{category.name}</h3>
            </div>
            
            <div className="skills-items-list">
              {category.skills.map((skill) => (
                <div key={skill.name} className="skills-item">
                  <FontAwesomeIcon icon={faCheck} className="skills-item-icon" />
                  <span className="skills-item-name">{skill.name}</span>
                  {skill.isFavorite && (
                    <span className="skills-pro-badge">
                      <FontAwesomeIcon icon={faStar} />
                      <span>Experienced</span>
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;